
class SizeGuide extends HTMLElement {
	constructor() {
		super();

		const scrollHandler = content => {
			if (content.scrollLeft <= 4) content.classList.remove('scroll-left');
			else content.classList.add('scroll-left');

			if (content.scrollLeft >= content.scrollWidth - content.clientWidth - 4) content.classList.remove('scroll-right');
			else content.classList.add('scroll-right');
		}

		for (const content of this.querySelectorAll('.size-guide__dimensions')) {
			content.addEventListener('scroll', () => scrollHandler(content));
			const observer = new IntersectionObserver(entries => {
				if (entries.some(e => e.isIntersecting)) {
					scrollHandler(content);
					observer.disconnect();
				}
			});
			observer.observe(content);
		}

		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				this.querySelector('size-guide-tab[aria-selected="true"]').scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'center'});
				observer.disconnect();
			}
		});
		observer.observe(this);

		window.addEventListener('opensizeguide', e => {
			const handle = this.getAttribute('handle');
			if (handle === e.detail.handle) {
				const modal = this.closest('slide-out-modal');
				if (modal) {
					modal.open();
					this.selectType(e.detail.type);
				}
			}
		});
	}

	connectedCallback() {
		setTimeout(() => {
			const type = this.getAttribute('type');
			if (type) this.selectType(type);
		})
	}

	selectType(type) {
		// Try to automatically click on correct tab for product type
		let match = null;
		let matchCount = 0;
		let tabs = this.querySelectorAll('size-guide-tab')

		const split = str => str
			.toLowerCase()
			.trim()
			.replace(' in ', ' ')
			.replace('100% french flax linen', '')
			.replace('linen', '')
			.replace(/[^a-z\s]/g, '')
			.split(/\s+/);
		
		let toMatch = [...split(type)]
			.filter((i, idx, arr) => arr.indexOf(i) === idx);

		console.log(toMatch);

		for (let tab of tabs) {
			let tabWords = split(tab.innerText);
			let matches = tabWords.filter(word => toMatch.find(item => item.includes(word) || word.includes(item)));
			let matchLength = matches.reduce((acc, cur) => acc + cur.length, 0);
			console.log(tab.innerText, matches, matchLength);

			if (matchLength > matchCount && matchLength > 3) {
				match = tab;
				matchCount = matchLength;
			}
		}

		if (match) match.select();
	}
}

class SizeGuideUnitToggle extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', e => {
			e.stopPropagation();
			e.preventDefault();
			this.update();
			return false;
		});
	}

	connectedCallback() {
		this.update();
	}

	update() {
		const selected = this.querySelector('input:checked');
		const unit = selected.value;
		
		const cells = this.closest('.size-guide__modal, .size-guide__page').querySelectorAll('size-guide td[data-unit]');
		
		for (const cell of cells) {
			const cellValue = parseFloat(cell.dataset.value);
			const convertedValue = this.convert(cellValue, cell.dataset.unit, unit);
			cell.innerHTML = `${convertedValue.toFixed(1).replace('.0', '')} ${unit}`;
		}
	}

	convert(value, fromUnit, toUnit) {
		if (fromUnit === toUnit) return value;
		if (fromUnit === 'cm' && toUnit === 'in') return value / 2.54;
		if (fromUnit === 'in' && toUnit === 'cm') return value * 2.54;
	}
}

class SizeGuideTab extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', () => {
			this.select();
		});

		this.location = this.getAttribute('location');
	}

	select() {
		this.parentElement.querySelectorAll('size-guide-tab').forEach(tab => tab.setAttribute('aria-selected', false));
		this.setAttribute('aria-selected', true);
		setTimeout(() => this.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'}));

		const name = this.getAttribute('name');

		if (this.getAttribute('aria-controls')) { // No section specified, select all
			this.closest('size-guide, .size-guide__page').querySelectorAll(`[name="${name}"]:not(size-guide-tab)`).forEach(content => content.hidden = true);
			this.closest('size-guide, .size-guide__page').querySelector(`#${this.getAttribute('aria-controls')}[name="${name}"]`).hidden = false;
		}
		else this.closest('size-guide, .size-guide__page').querySelectorAll(`[name="${name}"]`).forEach(content => content.hidden = false);

		if (this.location) {
			window.trackEvent(this.location, 'Size-Guide-Tabs', null, this.innerText.trim());
		}
	}
}

customElements.define('size-guide-unit-toggle', SizeGuideUnitToggle);
customElements.define('size-guide-tab', SizeGuideTab);
customElements.define('size-guide', SizeGuide);